// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Outfit:wght@300;400;500;600&family=Noto+Serif+SC:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.invisible{
  visibility: hidden;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.inset-0{
  inset: 0px;
}
.inset-2{
  inset: 0.5rem;
}
.inset-4{
  inset: 1rem;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-10{
  bottom: -2.5rem;
}
.-bottom-12{
  bottom: -3rem;
}
.-bottom-2{
  bottom: -0.5rem;
}
.-left-12{
  left: -3rem;
}
.-right-10{
  right: -2.5rem;
}
.-right-12{
  right: -3rem;
}
.-top-0\\.5{
  top: -0.125rem;
}
.-top-12{
  top: -3rem;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-2{
  bottom: 0.5rem;
}
.bottom-3{
  bottom: 0.75rem;
}
.bottom-\\[-17px\\]{
  bottom: -17px;
}
.left-0{
  left: 0px;
}
.left-1{
  left: 0.25rem;
}
.left-1\\/2{
  left: 50%;
}
.left-2{
  left: 0.5rem;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[50\\%\\]{
  left: 50%;
}
.right-0{
  right: 0px;
}
.right-1{
  right: 0.25rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-8{
  top: 2rem;
}
.top-\\[1px\\]{
  top: 1px;
}
.top-\\[28\\%\\]{
  top: 28%;
}
.top-\\[50\\%\\]{
  top: 50%;
}
.top-\\[60\\%\\]{
  top: 60%;
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[80\\]{
  z-index: 80;
}
.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}
.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-ml-1{
  margin-left: -0.25rem;
}
.-ml-4{
  margin-left: -1rem;
}
.-mt-4{
  margin-top: -1rem;
}
.-mt-40{
  margin-top: -10rem;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-10{
  margin-bottom: 2.5rem;
}
.mb-12{
  margin-bottom: 3rem;
}
.mb-14{
  margin-bottom: 3.5rem;
}
.mb-16{
  margin-bottom: 4rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-20{
  margin-bottom: 5rem;
}
.mb-24{
  margin-bottom: 6rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-2{
  margin-right: 0.5rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-20{
  margin-top: 5rem;
}
.mt-24{
  margin-top: 6rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-32{
  margin-top: 8rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-auto{
  margin-top: auto;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-\\[2\\/3\\]{
  aspect-ratio: 2/3;
}
.aspect-\\[3\\/4\\]{
  aspect-ratio: 3/4;
}
.aspect-\\[4096\\/2894\\]{
  aspect-ratio: 4096/2894;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.h-0{
  height: 0px;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-14{
  height: 3.5rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-32{
  height: 8rem;
}
.h-4{
  height: 1rem;
}
.h-48{
  height: 12rem;
}
.h-5{
  height: 1.25rem;
}
.h-7{
  height: 1.75rem;
}
.h-8{
  height: 2rem;
}
.h-9{
  height: 2.25rem;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[2px\\]{
  height: 2px;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[70vh\\]{
  height: 70vh;
}
.h-\\[85\\%\\]{
  height: 85%;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
  height: var(--radix-navigation-menu-viewport-height);
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
  height: var(--radix-select-trigger-height);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.max-h-\\[--radix-context-menu-content-available-height\\]{
  max-height: var(--radix-context-menu-content-available-height);
}
.max-h-\\[--radix-select-content-available-height\\]{
  max-height: var(--radix-select-content-available-height);
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[var\\(--radix-dropdown-menu-content-available-height\\)\\]{
  max-height: var(--radix-dropdown-menu-content-available-height);
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[60px\\]{
  min-height: 60px;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0{
  width: 0px;
}
.w-10{
  width: 2.5rem;
}
.w-12{
  width: 3rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-3\\/4{
  width: 75%;
}
.w-32{
  width: 8rem;
}
.w-4{
  width: 1rem;
}
.w-4\\/5{
  width: 80%;
}
.w-5{
  width: 1.25rem;
}
.w-6{
  width: 1.5rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-9{
  width: 2.25rem;
}
.w-\\[100px\\]{
  width: 100px;
}
.w-\\[1px\\]{
  width: 1px;
}
.w-auto{
  width: auto;
}
.w-full{
  width: 100%;
}
.w-max{
  width: max-content;
}
.w-px{
  width: 1px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-10{
  min-width: 2.5rem;
}
.min-w-8{
  min-width: 2rem;
}
.min-w-9{
  min-width: 2.25rem;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[35px\\]{
  min-width: 35px;
}
.min-w-\\[8rem\\]{
  min-width: 8rem;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
  min-width: var(--radix-select-trigger-width);
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1400px\\]{
  max-width: 1400px;
}
.max-w-\\[310px\\]{
  max-width: 310px;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-max{
  max-width: max-content;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-xl{
  max-width: 36rem;
}
.flex-1{
  flex: 1 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.grow-0{
  flex-grow: 0;
}
.basis-full{
  flex-basis: 100%;
}
.caption-bottom{
  caption-side: bottom;
}
.border-collapse{
  border-collapse: collapse;
}
.origin-\\[--radix-context-menu-content-transform-origin\\]{
  transform-origin: var(--radix-context-menu-content-transform-origin);
}
.origin-\\[--radix-dropdown-menu-content-transform-origin\\]{
  transform-origin: var(--radix-dropdown-menu-content-transform-origin);
}
.origin-\\[--radix-hover-card-content-transform-origin\\]{
  transform-origin: var(--radix-hover-card-content-transform-origin);
}
.origin-\\[--radix-menubar-content-transform-origin\\]{
  transform-origin: var(--radix-menubar-content-transform-origin);
}
.origin-\\[--radix-popover-content-transform-origin\\]{
  transform-origin: var(--radix-popover-content-transform-origin);
}
.origin-\\[--radix-select-content-transform-origin\\]{
  transform-origin: var(--radix-select-content-transform-origin);
}
.origin-\\[--radix-tooltip-content-transform-origin\\]{
  transform-origin: var(--radix-tooltip-content-transform-origin);
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\]{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[-50\\%\\]{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.touch-none{
  touch-action: none;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row{
  flex-direction: row;
}
.flex-col{
  flex-direction: column;
}
.flex-col-reverse{
  flex-direction: column-reverse;
}
.flex-wrap{
  flex-wrap: wrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-\\[\\#C9A227\\]\\/10 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(201 162 39 / 0.1);
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.break-words{
  overflow-wrap: break-word;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-\\[inherit\\]{
  border-radius: inherit;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: var(--radius);
}
.rounded-md{
  border-radius: calc(var(--radius) - 2px);
}
.rounded-sm{
  border-radius: calc(var(--radius) - 4px);
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-t-\\[10px\\]{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-tl-sm{
  border-top-left-radius: calc(var(--radius) - 4px);
}
.border{
  border-width: 1px;
}
.border-2{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-l{
  border-left-width: 1px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-\\[\\#7A7C7D\\]\\/20{
  border-color: rgb(122 124 125 / 0.2);
}
.border-\\[\\#C9A227\\]{
  --tw-border-opacity: 1;
  border-color: rgb(201 162 39 / var(--tw-border-opacity, 1));
}
.border-\\[\\#C9A227\\]\\/10{
  border-color: rgb(201 162 39 / 0.1);
}
.border-\\[\\#C9A227\\]\\/15{
  border-color: rgb(201 162 39 / 0.15);
}
.border-\\[\\#C9A227\\]\\/20{
  border-color: rgb(201 162 39 / 0.2);
}
.border-\\[\\#C9A227\\]\\/25{
  border-color: rgb(201 162 39 / 0.25);
}
.border-\\[\\#C9A227\\]\\/30{
  border-color: rgb(201 162 39 / 0.3);
}
.border-\\[\\#C9A227\\]\\/5{
  border-color: rgb(201 162 39 / 0.05);
}
.border-destructive{
  border-color: hsl(var(--destructive));
}
.border-destructive\\/50{
  border-color: hsl(var(--destructive) / 0.5);
}
.border-input{
  border-color: hsl(var(--input));
}
.border-primary{
  border-color: hsl(var(--primary));
}
.border-primary\\/50{
  border-color: hsl(var(--primary) / 0.5);
}
.border-transparent{
  border-color: transparent;
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#080808\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(8 8 8 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#080808\\]\\/80{
  background-color: rgb(8 8 8 / 0.8);
}
.bg-\\[\\#0a0a0a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a0a0a\\]\\/60{
  background-color: rgb(10 10 10 / 0.6);
}
.bg-\\[\\#0e0e0e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(14 14 14 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#121212\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161616\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 22 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1a1a1a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C9A227\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(201 162 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#C9A227\\]\\/10{
  background-color: rgb(201 162 39 / 0.1);
}
.bg-\\[\\#C9A227\\]\\/20{
  background-color: rgb(201 162 39 / 0.2);
}
.bg-\\[\\#E8DDC8\\]\\/40{
  background-color: rgb(232 221 200 / 0.4);
}
.bg-accent{
  background-color: hsl(var(--accent));
}
.bg-background{
  background-color: hsl(var(--background));
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-border{
  background-color: hsl(var(--border));
}
.bg-card{
  background-color: hsl(var(--card));
}
.bg-destructive{
  background-color: hsl(var(--destructive));
}
.bg-foreground{
  background-color: hsl(var(--foreground));
}
.bg-muted{
  background-color: hsl(var(--muted));
}
.bg-muted\\/50{
  background-color: hsl(var(--muted) / 0.5);
}
.bg-popover{
  background-color: hsl(var(--popover));
}
.bg-primary{
  background-color: hsl(var(--primary));
}
.bg-primary\\/10{
  background-color: hsl(var(--primary) / 0.1);
}
.bg-primary\\/20{
  background-color: hsl(var(--primary) / 0.2);
}
.bg-secondary{
  background-color: hsl(var(--secondary));
}
.bg-transparent{
  background-color: transparent;
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.from-\\[\\#080808\\]{
  --tw-gradient-from: #080808 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 8 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#080808\\]\\/40{
  --tw-gradient-from: rgb(8 8 8 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(8 8 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#14120c\\]{
  --tw-gradient-from: #14120c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 18 12 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#080808\\]\\/40{
  --tw-gradient-to: rgb(8 8 8 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(8 8 8 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#080808\\]\\/85{
  --tw-gradient-to: rgb(8 8 8 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(8 8 8 / 0.85) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#080808\\]\\/60{
  --tw-gradient-to: rgb(8 8 8 / 0.6) var(--tw-gradient-to-position);
}
.to-\\[\\#0a0a0a\\]{
  --tw-gradient-to: #0a0a0a var(--tw-gradient-to-position);
}
.to-\\[\\#14120c\\]{
  --tw-gradient-to: #14120c var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-center{
  background-position: center;
}
.bg-no-repeat{
  background-repeat: no-repeat;
}
.fill-current{
  fill: currentColor;
}
.fill-primary{
  fill: hsl(var(--primary));
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-1{
  padding: 0.25rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-3{
  padding: 0.75rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-7{
  padding: 1.75rem;
}
.p-8{
  padding: 2rem;
}
.p-\\[1px\\]{
  padding: 1px;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-40{
  padding-top: 10rem;
  padding-bottom: 10rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-12{
  padding-bottom: 3rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-24{
  padding-bottom: 6rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-12{
  padding-left: 3rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-2\\.5{
  padding-left: 0.625rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-8{
  padding-left: 2rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-2\\.5{
  padding-right: 0.625rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pr-8{
  padding-right: 2rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-10{
  padding-top: 2.5rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-28{
  padding-top: 7rem;
}
.pt-32{
  padding-top: 8rem;
}
.pt-4{
  padding-top: 1rem;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.align-middle{
  vertical-align: middle;
}
.font-mono{
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-7xl{
  font-size: 4.5rem;
  line-height: 1;
}
.text-9xl{
  font-size: 8rem;
  line-height: 1;
}
.text-\\[0\\.8rem\\]{
  font-size: 0.8rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12rem\\]{
  font-size: 12rem;
}
.text-\\[14rem\\]{
  font-size: 14rem;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.italic{
  font-style: italic;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.15em\\]{
  letter-spacing: 0.15em;
}
.tracking-\\[0\\.25em\\]{
  letter-spacing: 0.25em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-\\[0\\.35em\\]{
  letter-spacing: 0.35em;
}
.tracking-\\[0\\.3em\\]{
  letter-spacing: 0.3em;
}
.tracking-\\[0\\.4em\\]{
  letter-spacing: 0.4em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#7A7C7D\\]{
  --tw-text-opacity: 1;
  color: rgb(122 124 125 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B01218\\]{
  --tw-text-opacity: 1;
  color: rgb(176 18 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#B3B6B7\\]{
  --tw-text-opacity: 1;
  color: rgb(179 182 183 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C9A227\\]{
  --tw-text-opacity: 1;
  color: rgb(201 162 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#C9A227\\]\\/30{
  color: rgb(201 162 39 / 0.3);
}
.text-\\[\\#C9A227\\]\\/70{
  color: rgb(201 162 39 / 0.7);
}
.text-\\[\\#C9A227\\]\\/80{
  color: rgb(201 162 39 / 0.8);
}
.text-\\[\\#E8DDC8\\]{
  --tw-text-opacity: 1;
  color: rgb(232 221 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#E8DDC8\\]\\/60{
  color: rgb(232 221 200 / 0.6);
}
.text-\\[\\#E8DDC8\\]\\/70{
  color: rgb(232 221 200 / 0.7);
}
.text-accent-foreground{
  color: hsl(var(--accent-foreground));
}
.text-card-foreground{
  color: hsl(var(--card-foreground));
}
.text-current{
  color: currentColor;
}
.text-destructive{
  color: hsl(var(--destructive));
}
.text-destructive-foreground{
  color: hsl(var(--destructive-foreground));
}
.text-foreground{
  color: hsl(var(--foreground));
}
.text-foreground\\/50{
  color: hsl(var(--foreground) / 0.5);
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.text-popover-foreground{
  color: hsl(var(--popover-foreground));
}
.text-primary{
  color: hsl(var(--primary));
}
.text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.text-secondary-foreground{
  color: hsl(var(--secondary-foreground));
}
.underline{
  text-decoration-line: underline;
}
.decoration-\\[\\#C9A227\\]\\/20{
  text-decoration-color: rgb(201 162 39 / 0.2);
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-15{
  opacity: 0.15;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-5{
  opacity: 0.05;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring-0{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-ring{
  --tw-ring-color: hsl(var(--ring));
}
.ring-offset-background{
  --tw-ring-offset-color: hsl(var(--background));
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-\\[0_4px_12px_rgba\\(201\\2c 162\\2c 39\\2c 0\\.15\\)\\]{
  --tw-drop-shadow: drop-shadow(0 4px 12px rgba(201,162,39,0.15));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[30\\%\\]{
  --tw-grayscale: grayscale(30%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-2xl{
  --tw-backdrop-blur: blur(40px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000{
  transition-duration: 1000ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@keyframes enter{

  from{
    opacity: var(--tw-enter-opacity, 1);
    transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
  }
}
@keyframes exit{

  to{
    opacity: var(--tw-exit-opacity, 1);
    transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
  }
}
.animate-in{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.fade-in-0{
  --tw-enter-opacity: 0;
}
.zoom-in-95{
  --tw-enter-scale: .95;
}
.duration-1000{
  animation-duration: 1000ms;
}
.duration-150{
  animation-duration: 150ms;
}
.duration-200{
  animation-duration: 200ms;
}
.duration-300{
  animation-duration: 300ms;
}
.duration-500{
  animation-duration: 500ms;
}
.duration-700{
  animation-duration: 700ms;
}
.ease-in-out{
  animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

:root {
  --ink: #080808;
  --ink-soft: #121212;
  --gold: #C9A227;
  --gold-soft: #8A6A1F;
  --crimson: #8B1111;
  --crimson-bright: #B01218;
  --jade: #0F8B6D;
  --jade-dark: #0A4F43;
  --ivory: #E8DDC8;
  --mist: #B3B6B7;
  --mute: #7A7C7D;
}
/* ==========================================================================
   NEU: BLEND-MODE HOVER EFFECTS (Mit der Glitter-Textur)
   ========================================================================== */

:root {
    --glitter: url("https://assets.codepen.io/13471/silver-glitter-background.png");
}

/* Basis für die Elementarkarten */
.card-elemental {
    position: relative;
    overflow: hidden;
    z-index: 1;
}

/* Der magische Animations-Container (wird erst beim Hover sichtbar) */
.card-elemental::after {
    content: "";
    position: absolute;
    inset: 0;
    opacity: 0;
    z-index: -1; /* Hinter dem Text */
    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
    background-repeat: repeat, repeat, repeat, no-repeat;
}

/* Aktivierung beim Hovern */
.card-elemental:hover::after {
    opacity: 0.25; /* Leicht erhöht, da Filter Helligkeit schlucken */
}

/* --- 1. FEUER (Dein Original-Effekt, optimiert für den Kasten) --- */
.elem-fire:hover { border-color: rgba(176, 18, 24, 0.6); }
.elem-fire::after {
    background-image: 
        var(--glitter), 
        var(--glitter),
        linear-gradient(0deg, #fff 0px, var(--crimson-bright) 15%, #dcbc169c 50%, transparent 85%),
        radial-gradient(ellipse at bottom, transparent 40%, #000 70%);
    background-size: 350px 500px, 400px 650px, 100% 100%, 100% 100%;
    background-blend-mode: hard-light, color-dodge, multiply;
    mix-blend-mode: color-dodge;
    filter: brightness(2.5) blur(4px) contrast(5);
}
.elem-fire:hover::after {
    animation: magic-fire 2s linear infinite;
}
@keyframes magic-fire {
    0% { background-position: center 0px, center 0px, 50% 100%, center center; }
    100% { background-position: center -500px, center -650px, 50% 100%, center center; }
}

/* --- 2. WASSER (Fließende Welle nach oben/unten) --- */
.elem-water:hover { border-color: rgba(46, 120, 168, 0.6); }
.elem-water::after {
    background-image: 
        var(--glitter), 
        var(--glitter),
        linear-gradient(180deg, transparent 10%, #2e78a8 40%, #fff 60%, #121212 90%),
        radial-gradient(circle at center, transparent 20%, #000 80%);
    background-size: 300px 400px, 350px 450px, 100% 100%, 100% 100%;
    background-blend-mode: overlay, screen, multiply;
    mix-blend-mode: color-dodge;
    filter: brightness(2) blur(5px) contrast(4);
}
.elem-water:hover::after {
    animation: magic-water 2.5s linear infinite;
}
@keyframes magic-water {
    0% { background-position: 0px 0px, 0px 0px, 50% 100%, center center; }
    100% { background-position: -300px 400px, 350px 450px, 50% 100%, center center; }
}

/* --- 3. LUFT (Sanfter, goldener Nebelwirbel) --- */
.elem-air:hover { border-color: rgba(229, 197, 71, 0.6); }
.elem-air::after {
    background-image: 
        var(--glitter), 
        var(--glitter),
        linear-gradient(135deg, transparent 20%, var(--gold) 50%, transparent 80%),
        radial-gradient(circle at center, transparent 30%, #000 90%);
    background-size: 500px 500px, 600px 600px, 100% 100%, 100% 100%;
    background-blend-mode: hard-light, color-dodge, multiply;
    mix-blend-mode: color-dodge;
    filter: brightness(2) blur(6px) contrast(3);
}
.elem-air:hover::after {
    animation: magic-air 4s linear infinite;
}
@keyframes magic-air {
    0% { background-position: 0px 0px, 0px 0px, 0% 0%, center center; }
    100% { background-position: 500px -500px, -600px 600px, 0% 0%, center center; }
}

/* --- 4. ERDE (Jade-Flimmern, das von unten hochsteigt) --- */
.elem-earth:hover { border-color: rgba(15, 139, 109, 0.6); }
.elem-earth::after {
    background-image: 
        var(--glitter), 
        var(--glitter),
        linear-gradient(0deg, var(--jade) 0%, var(--jade-dark) 40%, transparent 80%),
        radial-gradient(ellipse at bottom, transparent 20%, #000 80%);
    background-size: 250px 400px, 300px 500px, 100% 100%, 100% 100%;
    background-blend-mode: color-dodge, multiply, multiply;
    mix-blend-mode: color-dodge;
    filter: brightness(1.8) blur(3px) contrast(4);
}
.elem-earth:hover::after {
    animation: magic-earth 3s linear infinite;
}
@keyframes magic-earth {
    0% { background-position: center 0px, center 0px, 50% 100%, center center; }
    100% { background-position: center -400px, center 500px, 50% 100%, center center; }
}

/* --- 5. ELYRA (Kosmisches, imperiales Gold-Shimmern) --- */
.elem-elyra:hover { border-color: var(--gold); }
.elem-elyra::after {
    background-image: 
        var(--glitter), 
        var(--glitter),
        linear-gradient(90deg, transparent 0%, var(--gold) 50%, transparent 100%),
        radial-gradient(circle at center, transparent 10%, #000 80%);
    background-size: 400px 400px, 500px 500px, 200% 100%, 100% 100%;
    background-blend-mode: hard-light, color-dodge, multiply;
    mix-blend-mode: color-dodge;
    filter: brightness(2.2) blur(5px) contrast(4);
}
.elem-elyra:hover::after {
    animation: magic-elyra 2s linear infinite;
}
@keyframes magic-elyra {
    0% { background-position: 0px 0px, 0px 0px, -100% 0%, center center; }
    100% { background-position: 400px -400px, -500px 500px, 100% 0%, center center; }
}

* {
  border-color: rgba(201, 162, 39, 0.15);
}

html, body {
  margin: 0;
  padding: 0;
  background: var(--ink);
  color: var(--ivory);
  font-family: 'Outfit', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  scroll-behavior: smooth;
}

body {
  background-color: var(--ink);
  background-image:
    radial-gradient(circle at 20% 10%, rgba(139, 17, 17, 0.10), transparent 40%),
    radial-gradient(circle at 80% 80%, rgb(0, 0, 0), transparent 50%),
    radial-gradient(circle at 50% 50%, rgba(201, 162, 39, 0.04), transparent 60%);
  min-height: 100vh;
}

/* Grain / noise overlay */
body::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 1;
  opacity: 0.04;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.8'/></svg>");
}

h1, h2, h3, h4, h5, .serif {
  font-family: 'Cormorant Garamond', serif;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.chinese {
  font-family: 'Noto Serif SC', serif;
}

::selection {
  background: rgba(201, 162, 39, 0.35);
  color: #fff;
}

/* Custom scrollbar */
::-webkit-scrollbar { width: 8px; height: 8px; }
::-webkit-scrollbar-track { background: var(--ink); }
::-webkit-scrollbar-thumb { background: rgba(201, 162, 39, 0.3); border-radius: 8px; }
::-webkit-scrollbar-thumb:hover { background: rgba(201, 162, 39, 0.6); }

/* Reusable utilities */
.gold { color: var(--gold); }
.crimson { color: var(--crimson-bright); }
.jade { color: var(--jade); }
.ivory { color: var(--ivory); }
.mist { color: var(--mist); }

.btn-imperial {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.9rem 2.2rem;
  border: 1px solid var(--gold);
  background: transparent;
  color: var(--ivory);
  font-family: 'Outfit', sans-serif;
  font-weight: 400;
  font-size: 0.95rem;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(.4,0,.2,1);
  position: relative;
  overflow: hidden;
}
.btn-imperial::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--crimson);
  transform: translateY(101%);
  transition: transform 0.45s cubic-bezier(.7,0,.3,1);
  z-index: -1;
}
.btn-imperial:hover { color: #fff; border-color: var(--crimson); }
.btn-imperial:hover::before { transform: translateY(0); }

.btn-ghost {
  display: inline-flex; align-items: center; gap: 0.5rem;
  padding: 0.7rem 1.6rem;
  border: 1px solid rgba(201,162,39,0.35);
  background: transparent; color: var(--ivory);
  font-size: 0.85rem; letter-spacing: 0.2em; text-transform: uppercase;
  cursor: pointer; transition: all 0.3s;
}
.btn-ghost:hover { border-color: var(--gold); background: rgba(201,162,39,0.08); }

.ornament {
  display: inline-block;
  color: var(--gold);
  font-size: 1.2rem;
  letter-spacing: 1rem;
  opacity: 0.6;
}

.divider-gold {
  position: relative;
  height: 1px;
  background: linear-gradient(to right, transparent, rgba(201,162,39,0.5), transparent);
}
.divider-gold::after {
  content: '◆';
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  color: var(--gold);
  background: var(--ink);
  padding: 0 0.8rem;
  font-size: 0.7rem;
}

.card-imperial {
  background: linear-gradient(180deg, rgba(18,18,18,0.95), rgba(8,8,8,0.95));
  border: 1px solid rgba(201,162,39,0.18);
  transition: all 0.45s cubic-bezier(.4,0,.2,1);
  position: relative;
  overflow: hidden;
}
.card-imperial::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
  background: linear-gradient(to right, transparent, var(--gold), transparent);
  opacity: 0;
  transition: opacity 0.4s;
}
.card-imperial:hover {
  border-color: rgba(139,17,17,0.6);
  transform: translateY(-4px);
}
.card-imperial:hover::before { opacity: 1; }

/* Lantern animation */
@keyframes lanternSway {
  0%, 100% { transform: translateY(0) rotate(-2deg); }
  50% { transform: translateY(-10px) rotate(2deg); }
}
@keyframes lanternGlow {
  0%, 100% { box-shadow: 0 0 30px 8px rgba(176, 18, 24, 0.4), 0 0 60px 20px rgba(201, 162, 39, 0.2); }
  50% { box-shadow: 0 0 40px 12px rgba(176, 18, 24, 0.6), 0 0 80px 28px rgba(201, 162, 39, 0.3); }
}
.lantern {
  position: absolute;
  width: 50px; height: 70px;
  background: radial-gradient(ellipse at center, #d92b2b 0%, #8B1111 60%, #5a0a0a 100%);
  border-radius: 50% / 60%;
  animation: lanternSway 5s ease-in-out infinite, lanternGlow 4s ease-in-out infinite;
  border-top: 3px solid #C9A227;
  border-bottom: 3px solid #C9A227;
}
.lantern::before {
  content: '';
  position: absolute;
  top: -25px; left: 50%;
  width: 1px; height: 25px;
  background: rgba(201,162,39,0.4);
  transform: translateX(-50%);
}
.lantern::after {
  content: '';
  position: absolute;
  bottom: -12px; left: 50%;
  width: 2px; height: 12px;
  background: var(--gold);
  transform: translateX(-50%);
}

/* Mist drift */
@keyframes mistDrift {
  0% { transform: translateX(-30%) translateY(0); opacity: 0; }
  20% { opacity: 0.7; }
  80% { opacity: 0.5; }
  100% { transform: translateX(130%) translateY(-20px); opacity: 0; }
}
.mist-cloud {
  position: absolute;
  width: 500px; height: 200px;
  background: radial-gradient(ellipse, rgba(179,182,183,0.18) 0%, transparent 65%);
  filter: blur(40px);
  animation: mistDrift 28s linear infinite;
  pointer-events: none;
}

/* Ember particle */
@keyframes ember {
  0% { transform: translateY(0) translateX(0); opacity: 0; }
  10% { opacity: 1; }
  100% { transform: translateY(-100vh) translateX(40px); opacity: 0; }
}
.ember {
  position: absolute;
  width: 3px; height: 3px;
  background: var(--gold);
  border-radius: 50%;
  box-shadow: 0 0 6px 2px rgba(201,162,39,0.6);
  animation: ember linear infinite;
  bottom: 0;
}

/* Fade in animation utilities */
@keyframes fadeUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}
.fade-up { animation: fadeUp 1.2s ease-out forwards; }

/* Hero gradient overlay */
.hero-overlay {
  background:
    linear-gradient(180deg, rgba(8,8,8,0.45) 0%, rgba(8,8,8,0.6) 50%, var(--ink) 100%);
}

/* Tarot card style */
.tarot-card {
  background: linear-gradient(160deg, #1a1209 0%, #0a0805 100%);
  border: 1px solid rgba(201,162,39,0.4);
  position: relative;
  aspect-ratio: 2 / 3;
  overflow: hidden;
}
.tarot-card::before {
  content: '';
  position: absolute;
  inset: 8px;
  border: 1px solid rgba(201,162,39,0.25);
  pointer-events: none;
}
.tarot-card::after {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 50% 30%, rgba(201,162,39,0.15), transparent 60%);
  pointer-events: none;
}

/* Timeline node glow */
.book-node {
  position: relative;
  width: 14px; height: 14px;
  background: var(--gold);
  border-radius: 50%;
  box-shadow: 0 0 12px 2px rgba(201,162,39,0.6);
}

/* Chinese-style corner ornament */
.corner-orn {
  position: absolute;
  width: 28px; height: 28px;
  border: 1px solid var(--gold);
  opacity: 0.6;
}
.corner-orn.tl { top: 8px; left: 8px; border-right: none; border-bottom: none; }
.corner-orn.tr { top: 8px; right: 8px; border-left: none; border-bottom: none; }
.corner-orn.bl { bottom: 8px; left: 8px; border-right: none; border-top: none; }
.corner-orn.br { bottom: 8px; right: 8px; border-left: none; border-top: none; }

/* Hide debug wrapper */
[data-debug-wrapper="true"] { display: contents !important; }
.file\\:border-0::file-selector-button{
  border-width: 0px;
}
.file\\:bg-transparent::file-selector-button{
  background-color: transparent;
}
.file\\:text-sm::file-selector-button{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.file\\:font-medium::file-selector-button{
  font-weight: 500;
}
.file\\:text-foreground::file-selector-button{
  color: hsl(var(--foreground));
}
.placeholder\\:text-muted-foreground::placeholder{
  color: hsl(var(--muted-foreground));
}
.after\\:absolute::after{
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-y-0::after{
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.after\\:left-1\\/2::after{
  content: var(--tw-content);
  left: 50%;
}
.after\\:w-1::after{
  content: var(--tw-content);
  width: 0.25rem;
}
.after\\:-translate-x-1\\/2::after{
  content: var(--tw-content);
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.first\\:rounded-l-md:first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.first\\:border-l:first-child{
  border-left-width: 1px;
}
.last\\:rounded-r-md:last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.focus-within\\:relative:focus-within{
  position: relative;
}
.focus-within\\:z-20:focus-within{
  z-index: 20;
}
.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:scale-\\[1\\.01\\]:hover{
  --tw-scale-x: 1.01;
  --tw-scale-y: 1.01;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:border-\\[\\#C9A227\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(201 162 39 / var(--tw-border-opacity, 1));
}
.hover\\:border-\\[\\#C9A227\\]\\/50:hover{
  border-color: rgb(201 162 39 / 0.5);
}
.hover\\:bg-\\[\\#C9A227\\]\\/5:hover{
  background-color: rgb(201 162 39 / 0.05);
}
.hover\\:bg-accent:hover{
  background-color: hsl(var(--accent));
}
.hover\\:bg-destructive\\/80:hover{
  background-color: hsl(var(--destructive) / 0.8);
}
.hover\\:bg-destructive\\/90:hover{
  background-color: hsl(var(--destructive) / 0.9);
}
.hover\\:bg-muted:hover{
  background-color: hsl(var(--muted));
}
.hover\\:bg-muted\\/50:hover{
  background-color: hsl(var(--muted) / 0.5);
}
.hover\\:bg-primary:hover{
  background-color: hsl(var(--primary));
}
.hover\\:bg-primary\\/80:hover{
  background-color: hsl(var(--primary) / 0.8);
}
.hover\\:bg-primary\\/90:hover{
  background-color: hsl(var(--primary) / 0.9);
}
.hover\\:bg-secondary:hover{
  background-color: hsl(var(--secondary));
}
.hover\\:bg-secondary\\/80:hover{
  background-color: hsl(var(--secondary) / 0.8);
}
.hover\\:text-\\[\\#C9A227\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(201 162 39 / var(--tw-text-opacity, 1));
}
.hover\\:text-\\[\\#E8DDC8\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(232 221 200 / var(--tw-text-opacity, 1));
}
.hover\\:text-accent-foreground:hover{
  color: hsl(var(--accent-foreground));
}
.hover\\:text-foreground:hover{
  color: hsl(var(--foreground));
}
.hover\\:text-muted-foreground:hover{
  color: hsl(var(--muted-foreground));
}
.hover\\:text-primary-foreground:hover{
  color: hsl(var(--primary-foreground));
}
.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover{
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover{
  opacity: 1;
}
.hover\\:opacity-80:hover{
  opacity: 0.8;
}
.focus\\:border-\\[\\#C9A227\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(201 162 39 / var(--tw-border-opacity, 1));
}
.focus\\:bg-accent:focus{
  background-color: hsl(var(--accent));
}
.focus\\:bg-primary:focus{
  background-color: hsl(var(--primary));
}
.focus\\:text-accent-foreground:focus{
  color: hsl(var(--accent-foreground));
}
.focus\\:text-primary-foreground:focus{
  color: hsl(var(--primary-foreground));
}
.focus\\:opacity-100:focus{
  opacity: 1;
}
.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus\\:ring-ring:focus{
  --tw-ring-color: hsl(var(--ring));
}
.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:ring-1:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.focus-visible\\:ring-ring:focus-visible{
  --tw-ring-color: hsl(var(--ring));
}
.focus-visible\\:ring-offset-1:focus-visible{
  --tw-ring-offset-width: 1px;
}
.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}
.focus-visible\\:ring-offset-background:focus-visible{
  --tw-ring-offset-color: hsl(var(--background));
}
.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}
.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}
.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}
.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-150{
  --tw-scale-x: 1.5;
  --tw-scale-y: 1.5;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-95{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.04\\]{
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:text-\\[\\#C9A227\\]{
  --tw-text-opacity: 1;
  color: rgb(201 162 39 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.group:hover .group-hover\\:opacity-0{
  opacity: 0;
}
.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}
.group:hover .group-hover\\:opacity-40{
  opacity: 0.4;
}
.group:hover .group-hover\\:opacity-60{
  opacity: 0.6;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
  border-color: hsl(var(--muted) / 0.4);
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
  border-color: hsl(var(--border));
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
  background-color: hsl(var(--muted));
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
  background-color: hsl(var(--primary));
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
  background-color: hsl(var(--background));
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
  color: hsl(var(--muted-foreground));
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
  color: hsl(var(--primary-foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
  color: hsl(var(--foreground));
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
  border-color: hsl(var(--destructive) / 0.3);
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
  background-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
  color: hsl(var(--destructive-foreground));
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
  --tw-text-opacity: 1;
  color: rgb(254 242 242 / var(--tw-text-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
  --tw-ring-color: hsl(var(--destructive));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1));
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
  --tw-ring-offset-color: #dc2626;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
  cursor: not-allowed;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
  opacity: 0.7;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
  opacity: 0.5;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
  background-color: hsl(var(--accent));
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
  background-color: hsl(var(--accent) / 0.5);
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
  color: hsl(var(--muted-foreground));
}
.aria-selected\\:opacity-100[aria-selected="true"]{
  opacity: 1;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
  pointer-events: none;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
  pointer-events: none;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
  height: 1px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
  width: 100%;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
  --tw-translate-y: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
  --tw-translate-x: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=checked\\]\\:translate-x-4[data-state="checked"]{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
  --tw-translate-x: var(--radix-toast-swipe-end-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
  --tw-translate-x: var(--radix-toast-swipe-move-x);
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes accordion-up{

  from{
    height: var(--radix-accordion-content-height);
  }

  to{
    height: 0;
  }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
  animation: accordion-up 0.2s ease-out;
}
@keyframes accordion-down{

  from{
    height: 0;
  }

  to{
    height: var(--radix-accordion-content-height);
  }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
  animation: accordion-down 0.2s ease-out;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
  flex-direction: column;
}
.data-\\[selected\\=true\\]\\:bg-accent[data-selected="true"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
  background-color: hsl(var(--background));
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
  background-color: hsl(var(--primary));
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
  background-color: hsl(var(--accent) / 0.5);
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
  background-color: hsl(var(--secondary));
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
  background-color: hsl(var(--muted));
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
  background-color: hsl(var(--input));
}
.data-\\[placeholder\\]\\:text-muted-foreground[data-placeholder]{
  color: hsl(var(--muted-foreground));
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
  color: hsl(var(--foreground));
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
  color: hsl(var(--primary-foreground));
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
  color: hsl(var(--accent-foreground));
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
  color: hsl(var(--muted-foreground));
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
  opacity: 0.5;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
  opacity: 0.5;
}
.data-\\[state\\=active\\]\\:shadow[data-state="active"]{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
  transition-property: none;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  transition-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  transition-duration: 500ms;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
  animation-name: enter;
  animation-duration: 150ms;
  --tw-enter-opacity: initial;
  --tw-enter-scale: initial;
  --tw-enter-rotate: initial;
  --tw-enter-translate-x: initial;
  --tw-enter-translate-y: initial;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
  animation-name: exit;
  animation-duration: 150ms;
  --tw-exit-opacity: initial;
  --tw-exit-scale: initial;
  --tw-exit-rotate: initial;
  --tw-exit-translate-x: initial;
  --tw-exit-translate-y: initial;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
  --tw-enter-opacity: 0;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
  --tw-exit-opacity: 0.8;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
  --tw-exit-opacity: 0;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
  --tw-enter-opacity: 0;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
  --tw-exit-scale: .95;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
  --tw-enter-scale: .9;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
  --tw-enter-scale: .95;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
  --tw-enter-translate-x: 13rem;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
  --tw-enter-translate-x: -13rem;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
  --tw-exit-translate-x: 13rem;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
  --tw-exit-translate-x: -13rem;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
  --tw-enter-translate-y: -0.5rem;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
  --tw-enter-translate-x: 0.5rem;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
  --tw-enter-translate-x: -0.5rem;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
  --tw-enter-translate-y: 0.5rem;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
  --tw-exit-translate-y: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
  --tw-exit-translate-x: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
  --tw-exit-translate-x: -50%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
  --tw-exit-translate-x: 100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
  --tw-exit-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
  --tw-exit-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
  --tw-enter-translate-y: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
  --tw-enter-translate-x: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
  --tw-enter-translate-x: -50%;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
  --tw-enter-translate-x: 100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
  --tw-enter-translate-y: -48%;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
  --tw-enter-translate-y: -100%;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
  animation-duration: 300ms;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
  animation-duration: 500ms;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  left: 0px;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  height: 0.25rem;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  width: 100%;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
  content: var(--tw-content);
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.data-\\[state\\=open\\]\\:hover\\:bg-accent:hover[data-state="open"]{
  background-color: hsl(var(--accent));
}
.data-\\[state\\=open\\]\\:focus\\:bg-accent:focus[data-state="open"]{
  background-color: hsl(var(--accent));
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.dark\\:border-destructive:is(.dark *){
  border-color: hsl(var(--destructive));
}
@media (min-width: 640px){

  .sm\\:bottom-0{
    bottom: 0px;
  }

  .sm\\:right-0{
    right: 0px;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:mt-0{
    margin-top: 0px;
  }

  .sm\\:h-64{
    height: 16rem;
  }

  .sm\\:min-w-\\[180px\\]{
    min-width: 180px;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-2\\.5{
    gap: 0.625rem;
  }

  .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--tw-space-x-reverse));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-lg{
    border-radius: var(--radius);
  }

  .sm\\:border-t-0{
    border-top-width: 0px;
  }

  .sm\\:pt-0{
    padding-top: 0px;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
    --tw-enter-translate-y: 100%;
  }
}
@media (min-width: 768px){

  .md\\:absolute{
    position: absolute;
  }

  .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
    width: var(--radix-navigation-menu-viewport-width);
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:max-w-\\[420px\\]{
    max-width: 420px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:border-l{
    border-left-width: 1px;
  }

  .md\\:border-l-\\[\\#C9A227\\]\\/10{
    border-left-color: rgb(201 162 39 / 0.1);
  }

  .md\\:pb-0{
    padding-bottom: 0px;
  }

  .md\\:pl-4{
    padding-left: 1rem;
  }

  .md\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (min-width: 1024px){

  .lg\\:left-1\\/2{
    left: 50%;
  }

  .lg\\:top-1\\/2{
    top: 50%;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:ml-0{
    margin-left: 0px;
  }

  .lg\\:ml-auto{
    margin-left: auto;
  }

  .lg\\:mr-0{
    margin-right: 0px;
  }

  .lg\\:mr-auto{
    margin-right: auto;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:w-1\\/2{
    width: 50%;
  }

  .lg\\:-translate-y-1\\/2{
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:pl-0{
    padding-left: 0px;
  }

  .lg\\:pl-14{
    padding-left: 3.5rem;
  }

  .lg\\:pr-14{
    padding-right: 3.5rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .lg\\:text-6xl{
    font-size: 3.75rem;
    line-height: 1;
  }

  .lg\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-8xl{
    font-size: 6rem;
    line-height: 1;
  }
}
@media (min-width: 1280px){

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:gap-6{
    gap: 1.5rem;
  }

  .xl\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .xl\\:tracking-\\[0\\.2em\\]{
    letter-spacing: 0.2em;
  }
}
.\\[\\&\\+div\\]\\:text-xs+div{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&\\:has\\(\\>\\.day-range-end\\)\\]\\:rounded-r-md:has(>.day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\>\\.day-range-start\\)\\]\\:rounded-l-md:has(>.day-range-start){
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-md:has([aria-selected]){
  border-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
  background-color: hsl(var(--accent));
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
  border-top-left-radius: calc(var(--radius) - 2px);
  border-bottom-left-radius: calc(var(--radius) - 2px);
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
  background-color: hsl(var(--accent) / 0.5);
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
  border-top-right-radius: calc(var(--radius) - 2px);
  border-bottom-right-radius: calc(var(--radius) - 2px);
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
  padding-right: 0px;
}
.\\[\\&\\>\\[role\\=checkbox\\]\\]\\:translate-y-\\[2px\\]>[role=checkbox]{
  --tw-translate-y: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
  --tw-translate-y: -3px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\>svg\\]\\:absolute>svg{
  position: absolute;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
  left: 1rem;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
  top: 1rem;
}
.\\[\\&\\>svg\\]\\:size-4>svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&\\>svg\\]\\:h-3\\.5>svg{
  height: 0.875rem;
}
.\\[\\&\\>svg\\]\\:w-3\\.5>svg{
  width: 0.875rem;
}
.\\[\\&\\>svg\\]\\:shrink-0>svg{
  flex-shrink: 0;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
  color: hsl(var(--destructive));
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
  color: hsl(var(--foreground));
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
  padding-left: 1.75rem;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
  border-bottom-width: 0px;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
  font-weight: 500;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
  color: hsl(var(--muted-foreground));
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
  padding-top: 0px;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
  width: 1.25rem;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
  height: 3rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
  height: 1.25rem;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
  width: 1.25rem;
}
.\\[\\&_p\\]\\:leading-relaxed p{
  line-height: 1.625;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
  pointer-events: none;
}
.\\[\\&_svg\\]\\:size-4 svg{
  width: 1rem;
  height: 1rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
  flex-shrink: 0;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
  border-width: 0px;
}
.\\[\\&_tr\\]\\:border-b tr{
  border-bottom-width: 1px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mCAAmB;IAAnB;EAAmB;AAAA;AAAnB;;EAAA;IAAA,kCAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA,qBAAmB;EAAnB,yBAAmB;EAAnB,2BAAmB;EAAnB,yBAAmB;EAAnB,0BAAmB;EAAnB,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;;+EAE+E;;AAE/E;IACI,+EAA+E;AACnF;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA,sEAAsE;AACtE;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW,EAAE,oBAAoB;IACjC,qDAAqD;IACrD,oBAAoB;IACpB,oDAAoD;AACxD;;AAEA,4BAA4B;AAC5B;IACI,aAAa,EAAE,kDAAkD;AACrE;;AAEA,sEAAsE;AACtE,mBAAmB,oCAAoC,EAAE;AACzD;IACI;;;;qEAIiE;IACjE,+DAA+D;IAC/D,wDAAwD;IACxD,2BAA2B;IAC3B,6CAA6C;AACjD;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,KAAK,oEAAoE,EAAE;IAC3E,OAAO,0EAA0E,EAAE;AACvF;;AAEA,wDAAwD;AACxD,oBAAoB,qCAAqC,EAAE;AAC3D;IACI;;;;oEAIgE;IAChE,+DAA+D;IAC/D,gDAAgD;IAChD,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI,2CAA2C;AAC/C;AACA;IACI,KAAK,8DAA8D,EAAE;IACrE,OAAO,uEAAuE,EAAE;AACpF;;AAEA,oDAAoD;AACpD,kBAAkB,qCAAqC,EAAE;AACzD;IACI;;;;oEAIgE;IAChE,+DAA+D;IAC/D,wDAAwD;IACxD,2BAA2B;IAC3B,2CAA2C;AAC/C;AACA;IACI,uCAAuC;AAC3C;AACA;IACI,KAAK,2DAA2D,EAAE;IAClE,OAAO,qEAAqE,EAAE;AAClF;;AAEA,8DAA8D;AAC9D,oBAAoB,qCAAqC,EAAE;AAC3D;IACI;;;;qEAIiE;IACjE,+DAA+D;IAC/D,sDAAsD;IACtD,2BAA2B;IAC3B,6CAA6C;AACjD;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,KAAK,oEAAoE,EAAE;IAC3E,OAAO,yEAAyE,EAAE;AACtF;;AAEA,4DAA4D;AAC5D,oBAAoB,yBAAyB,EAAE;AAC/C;IACI;;;;oEAIgE;IAChE,+DAA+D;IAC/D,wDAAwD;IACxD,2BAA2B;IAC3B,6CAA6C;AACjD;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,KAAK,8DAA8D,EAAE;IACrE,OAAO,uEAAuE,EAAE;AACpF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,iCAAiC;EACjC,mCAAmC;EACnC,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B;;;iFAG+E;EAC/E,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,aAAa;EACb,8SAA8S;AAChT;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,qBAAqB;AACrB,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,sBAAsB,EAAE;AACpD,4BAA4B,mCAAmC,EAAE,kBAAkB,EAAE;AACrF,kCAAkC,mCAAmC,EAAE;;AAEvE,uBAAuB;AACvB,QAAQ,kBAAkB,EAAE;AAC5B,WAAW,4BAA4B,EAAE;AACzC,QAAQ,kBAAkB,EAAE;AAC5B,SAAS,mBAAmB,EAAE;AAC9B,QAAQ,kBAAkB,EAAE;;AAE5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,0BAA0B;EAC1B,2BAA2B;EAC3B,mDAAmD;EACnD,WAAW;AACb;AACA,sBAAsB,WAAW,EAAE,4BAA4B,EAAE;AACjE,8BAA8B,wBAAwB,EAAE;;AAExD;EACE,oBAAoB,EAAE,mBAAmB,EAAE,WAAW;EACtD,sBAAsB;EACtB,uCAAuC;EACvC,uBAAuB,EAAE,mBAAmB;EAC5C,kBAAkB,EAAE,qBAAqB,EAAE,yBAAyB;EACpE,eAAe,EAAE,oBAAoB;AACvC;AACA,mBAAmB,yBAAyB,EAAE,iCAAiC,EAAE;;AAEjF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qFAAqF;AACvF;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,0EAA0E;EAC1E,uCAAuC;EACvC,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,4EAA4E;EAC5E,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;AACA,+BAA+B,UAAU,EAAE;;AAE3C,sBAAsB;AACtB;EACE,WAAW,sCAAsC,EAAE;EACnD,MAAM,yCAAyC,EAAE;AACnD;AACA;EACE,WAAW,sFAAsF,EAAE;EACnG,MAAM,uFAAuF,EAAE;AACjG;AACA;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,qFAAqF;EACrF,wBAAwB;EACxB,mFAAmF;EACnF,6BAA6B;EAC7B,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU,EAAE,SAAS;EACrB,UAAU,EAAE,YAAY;EACxB,gCAAgC;EAChC,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa,EAAE,SAAS;EACxB,UAAU,EAAE,YAAY;EACxB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,KAAK,yCAAyC,EAAE,UAAU,EAAE;EAC5D,MAAM,YAAY,EAAE;EACpB,MAAM,YAAY,EAAE;EACpB,OAAO,6CAA6C,EAAE,UAAU,EAAE;AACpE;AACA;EACE,kBAAkB;EAClB,YAAY,EAAE,aAAa;EAC3B,gFAAgF;EAChF,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,mBAAmB;AACnB;EACE,KAAK,sCAAsC,EAAE,UAAU,EAAE;EACzD,MAAM,UAAU,EAAE;EAClB,OAAO,8CAA8C,EAAE,UAAU,EAAE;AACrE;AACA;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,4CAA4C;EAC5C,gCAAgC;EAChC,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;AACA,WAAW,wCAAwC,EAAE;;AAErD,0BAA0B;AAC1B;EACE;sFACoF;AACtF;;AAEA,qBAAqB;AACrB;EACE,6DAA6D;EAC7D,sCAAsC;EACtC,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,uCAAuC;EACvC,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,sFAAsF;EACtF,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA,kCAAkC;AAClC;EACE,kBAAkB;EAClB,WAAW,EAAE,YAAY;EACzB,6BAA6B;EAC7B,YAAY;AACd;AACA,iBAAiB,QAAQ,EAAE,SAAS,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAC/E,iBAAiB,QAAQ,EAAE,UAAU,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC/E,iBAAiB,WAAW,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC/E,iBAAiB,WAAW,EAAE,UAAU,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;;AAE/E,uBAAuB;AACvB,8BAA8B,4BAA4B,EAAE;AA/a5D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,mBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D,QA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,iDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,kDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,2GA+a6D;EA/a7D,yGA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,2GA+a6D;EA/a7D,yGA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,2GA+a6D;EA/a7D,yGA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,2GA+a6D;EA/a7D,yGA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,yBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,iBA+a6D;EA/a7D,iBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,iBA+a6D;EA/a7D,iBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,+EA+a6D;EA/a7D,mGA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,yBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,yBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,gDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,iDA+a6D;EA/a7D;AA+a6D;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;AAAA;AA/a7D;EAAA;AA+a6D;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;AAAA;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,0EA+a6D;EA/a7D,8FA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D,yBA+a6D;EA/a7D,2BA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,+BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D,yBA+a6D;EA/a7D,2BA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,+BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D,yBA+a6D;EA/a7D,2BA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,+BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,wBA+a6D;EA/a7D,yBA+a6D;EA/a7D,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,wBA+a6D;EA/a7D,yBA+a6D;EA/a7D,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,wBA+a6D;EA/a7D,yBA+a6D;EA/a7D,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D,yBA+a6D;EA/a7D,0BA+a6D;EA/a7D,wBA+a6D;EA/a7D,yBA+a6D;EA/a7D,8BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,0BA+a6D;EA/a7D,qBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,mBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,uBA+a6D;IA/a7D,sDA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA,uBA+a6D;IA/a7D,oDA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA,uBA+a6D;IA/a7D,2DA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,iBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA;EA+a6D;AAAA;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,mBA+a6D;IA/a7D;EA+a6D;AAAA;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,sBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,oBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,eA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA,kBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA,iBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA,eA+a6D;IA/a7D;EA+a6D;AAAA;AA/a7D;;EAAA;IAAA;EA+a6D;;EA/a7D;IAAA;EA+a6D;;EA/a7D;IAAA,mBA+a6D;IA/a7D;EA+a6D;;EA/a7D;IAAA;EA+a6D;AAAA;AA/a7D;EAAA,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,iDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,iDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,kDA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,gBA+a6D;EA/a7D,oBA+a6D;EA/a7D,4BA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,sBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,WA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,mBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,qBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,kBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA,oBA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA,WA+a6D;EA/a7D;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D;AA/a7D;EAAA;AA+a6D","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&family=Outfit:wght@300;400;500;600&family=Noto+Serif+SC:wght@400;600;700&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n:root {\n  --ink: #080808;\n  --ink-soft: #121212;\n  --gold: #C9A227;\n  --gold-soft: #8A6A1F;\n  --crimson: #8B1111;\n  --crimson-bright: #B01218;\n  --jade: #0F8B6D;\n  --jade-dark: #0A4F43;\n  --ivory: #E8DDC8;\n  --mist: #B3B6B7;\n  --mute: #7A7C7D;\n}\n/* ==========================================================================\n   NEU: BLEND-MODE HOVER EFFECTS (Mit der Glitter-Textur)\n   ========================================================================== */\n\n:root {\n    --glitter: url(\"https://assets.codepen.io/13471/silver-glitter-background.png\");\n}\n\n/* Basis für die Elementarkarten */\n.card-elemental {\n    position: relative;\n    overflow: hidden;\n    z-index: 1;\n}\n\n/* Der magische Animations-Container (wird erst beim Hover sichtbar) */\n.card-elemental::after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    opacity: 0;\n    z-index: -1; /* Hinter dem Text */\n    transition: opacity 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n    pointer-events: none;\n    background-repeat: repeat, repeat, repeat, no-repeat;\n}\n\n/* Aktivierung beim Hovern */\n.card-elemental:hover::after {\n    opacity: 0.25; /* Leicht erhöht, da Filter Helligkeit schlucken */\n}\n\n/* --- 1. FEUER (Dein Original-Effekt, optimiert für den Kasten) --- */\n.elem-fire:hover { border-color: rgba(176, 18, 24, 0.6); }\n.elem-fire::after {\n    background-image: \n        var(--glitter), \n        var(--glitter),\n        linear-gradient(0deg, #fff 0px, var(--crimson-bright) 15%, #dcbc169c 50%, transparent 85%),\n        radial-gradient(ellipse at bottom, transparent 40%, #000 70%);\n    background-size: 350px 500px, 400px 650px, 100% 100%, 100% 100%;\n    background-blend-mode: hard-light, color-dodge, multiply;\n    mix-blend-mode: color-dodge;\n    filter: brightness(2.5) blur(4px) contrast(5);\n}\n.elem-fire:hover::after {\n    animation: magic-fire 2s linear infinite;\n}\n@keyframes magic-fire {\n    0% { background-position: center 0px, center 0px, 50% 100%, center center; }\n    100% { background-position: center -500px, center -650px, 50% 100%, center center; }\n}\n\n/* --- 2. WASSER (Fließende Welle nach oben/unten) --- */\n.elem-water:hover { border-color: rgba(46, 120, 168, 0.6); }\n.elem-water::after {\n    background-image: \n        var(--glitter), \n        var(--glitter),\n        linear-gradient(180deg, transparent 10%, #2e78a8 40%, #fff 60%, #121212 90%),\n        radial-gradient(circle at center, transparent 20%, #000 80%);\n    background-size: 300px 400px, 350px 450px, 100% 100%, 100% 100%;\n    background-blend-mode: overlay, screen, multiply;\n    mix-blend-mode: color-dodge;\n    filter: brightness(2) blur(5px) contrast(4);\n}\n.elem-water:hover::after {\n    animation: magic-water 2.5s linear infinite;\n}\n@keyframes magic-water {\n    0% { background-position: 0px 0px, 0px 0px, 50% 100%, center center; }\n    100% { background-position: -300px 400px, 350px 450px, 50% 100%, center center; }\n}\n\n/* --- 3. LUFT (Sanfter, goldener Nebelwirbel) --- */\n.elem-air:hover { border-color: rgba(229, 197, 71, 0.6); }\n.elem-air::after {\n    background-image: \n        var(--glitter), \n        var(--glitter),\n        linear-gradient(135deg, transparent 20%, var(--gold) 50%, transparent 80%),\n        radial-gradient(circle at center, transparent 30%, #000 90%);\n    background-size: 500px 500px, 600px 600px, 100% 100%, 100% 100%;\n    background-blend-mode: hard-light, color-dodge, multiply;\n    mix-blend-mode: color-dodge;\n    filter: brightness(2) blur(6px) contrast(3);\n}\n.elem-air:hover::after {\n    animation: magic-air 4s linear infinite;\n}\n@keyframes magic-air {\n    0% { background-position: 0px 0px, 0px 0px, 0% 0%, center center; }\n    100% { background-position: 500px -500px, -600px 600px, 0% 0%, center center; }\n}\n\n/* --- 4. ERDE (Jade-Flimmern, das von unten hochsteigt) --- */\n.elem-earth:hover { border-color: rgba(15, 139, 109, 0.6); }\n.elem-earth::after {\n    background-image: \n        var(--glitter), \n        var(--glitter),\n        linear-gradient(0deg, var(--jade) 0%, var(--jade-dark) 40%, transparent 80%),\n        radial-gradient(ellipse at bottom, transparent 20%, #000 80%);\n    background-size: 250px 400px, 300px 500px, 100% 100%, 100% 100%;\n    background-blend-mode: color-dodge, multiply, multiply;\n    mix-blend-mode: color-dodge;\n    filter: brightness(1.8) blur(3px) contrast(4);\n}\n.elem-earth:hover::after {\n    animation: magic-earth 3s linear infinite;\n}\n@keyframes magic-earth {\n    0% { background-position: center 0px, center 0px, 50% 100%, center center; }\n    100% { background-position: center -400px, center 500px, 50% 100%, center center; }\n}\n\n/* --- 5. ELYRA (Kosmisches, imperiales Gold-Shimmern) --- */\n.elem-elyra:hover { border-color: var(--gold); }\n.elem-elyra::after {\n    background-image: \n        var(--glitter), \n        var(--glitter),\n        linear-gradient(90deg, transparent 0%, var(--gold) 50%, transparent 100%),\n        radial-gradient(circle at center, transparent 10%, #000 80%);\n    background-size: 400px 400px, 500px 500px, 200% 100%, 100% 100%;\n    background-blend-mode: hard-light, color-dodge, multiply;\n    mix-blend-mode: color-dodge;\n    filter: brightness(2.2) blur(5px) contrast(4);\n}\n.elem-elyra:hover::after {\n    animation: magic-elyra 2s linear infinite;\n}\n@keyframes magic-elyra {\n    0% { background-position: 0px 0px, 0px 0px, -100% 0%, center center; }\n    100% { background-position: 400px -400px, -500px 500px, 100% 0%, center center; }\n}\n\n* {\n  border-color: rgba(201, 162, 39, 0.15);\n}\n\nhtml, body {\n  margin: 0;\n  padding: 0;\n  background: var(--ink);\n  color: var(--ivory);\n  font-family: 'Outfit', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  scroll-behavior: smooth;\n}\n\nbody {\n  background-color: var(--ink);\n  background-image:\n    radial-gradient(circle at 20% 10%, rgba(139, 17, 17, 0.10), transparent 40%),\n    radial-gradient(circle at 80% 80%, rgb(0, 0, 0), transparent 50%),\n    radial-gradient(circle at 50% 50%, rgba(201, 162, 39, 0.04), transparent 60%);\n  min-height: 100vh;\n}\n\n/* Grain / noise overlay */\nbody::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 1;\n  opacity: 0.04;\n  background-image: url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.8'/></svg>\");\n}\n\nh1, h2, h3, h4, h5, .serif {\n  font-family: 'Cormorant Garamond', serif;\n  font-weight: 500;\n  letter-spacing: -0.01em;\n}\n\n.chinese {\n  font-family: 'Noto Serif SC', serif;\n}\n\n::selection {\n  background: rgba(201, 162, 39, 0.35);\n  color: #fff;\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar { width: 8px; height: 8px; }\n::-webkit-scrollbar-track { background: var(--ink); }\n::-webkit-scrollbar-thumb { background: rgba(201, 162, 39, 0.3); border-radius: 8px; }\n::-webkit-scrollbar-thumb:hover { background: rgba(201, 162, 39, 0.6); }\n\n/* Reusable utilities */\n.gold { color: var(--gold); }\n.crimson { color: var(--crimson-bright); }\n.jade { color: var(--jade); }\n.ivory { color: var(--ivory); }\n.mist { color: var(--mist); }\n\n.btn-imperial {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n  padding: 0.9rem 2.2rem;\n  border: 1px solid var(--gold);\n  background: transparent;\n  color: var(--ivory);\n  font-family: 'Outfit', sans-serif;\n  font-weight: 400;\n  font-size: 0.95rem;\n  letter-spacing: 0.25em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(.4,0,.2,1);\n  position: relative;\n  overflow: hidden;\n}\n.btn-imperial::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: var(--crimson);\n  transform: translateY(101%);\n  transition: transform 0.45s cubic-bezier(.7,0,.3,1);\n  z-index: -1;\n}\n.btn-imperial:hover { color: #fff; border-color: var(--crimson); }\n.btn-imperial:hover::before { transform: translateY(0); }\n\n.btn-ghost {\n  display: inline-flex; align-items: center; gap: 0.5rem;\n  padding: 0.7rem 1.6rem;\n  border: 1px solid rgba(201,162,39,0.35);\n  background: transparent; color: var(--ivory);\n  font-size: 0.85rem; letter-spacing: 0.2em; text-transform: uppercase;\n  cursor: pointer; transition: all 0.3s;\n}\n.btn-ghost:hover { border-color: var(--gold); background: rgba(201,162,39,0.08); }\n\n.ornament {\n  display: inline-block;\n  color: var(--gold);\n  font-size: 1.2rem;\n  letter-spacing: 1rem;\n  opacity: 0.6;\n}\n\n.divider-gold {\n  position: relative;\n  height: 1px;\n  background: linear-gradient(to right, transparent, rgba(201,162,39,0.5), transparent);\n}\n.divider-gold::after {\n  content: '◆';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  color: var(--gold);\n  background: var(--ink);\n  padding: 0 0.8rem;\n  font-size: 0.7rem;\n}\n\n.card-imperial {\n  background: linear-gradient(180deg, rgba(18,18,18,0.95), rgba(8,8,8,0.95));\n  border: 1px solid rgba(201,162,39,0.18);\n  transition: all 0.45s cubic-bezier(.4,0,.2,1);\n  position: relative;\n  overflow: hidden;\n}\n.card-imperial::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 2px;\n  background: linear-gradient(to right, transparent, var(--gold), transparent);\n  opacity: 0;\n  transition: opacity 0.4s;\n}\n.card-imperial:hover {\n  border-color: rgba(139,17,17,0.6);\n  transform: translateY(-4px);\n}\n.card-imperial:hover::before { opacity: 1; }\n\n/* Lantern animation */\n@keyframes lanternSway {\n  0%, 100% { transform: translateY(0) rotate(-2deg); }\n  50% { transform: translateY(-10px) rotate(2deg); }\n}\n@keyframes lanternGlow {\n  0%, 100% { box-shadow: 0 0 30px 8px rgba(176, 18, 24, 0.4), 0 0 60px 20px rgba(201, 162, 39, 0.2); }\n  50% { box-shadow: 0 0 40px 12px rgba(176, 18, 24, 0.6), 0 0 80px 28px rgba(201, 162, 39, 0.3); }\n}\n.lantern {\n  position: absolute;\n  width: 50px; height: 70px;\n  background: radial-gradient(ellipse at center, #d92b2b 0%, #8B1111 60%, #5a0a0a 100%);\n  border-radius: 50% / 60%;\n  animation: lanternSway 5s ease-in-out infinite, lanternGlow 4s ease-in-out infinite;\n  border-top: 3px solid #C9A227;\n  border-bottom: 3px solid #C9A227;\n}\n.lantern::before {\n  content: '';\n  position: absolute;\n  top: -25px; left: 50%;\n  width: 1px; height: 25px;\n  background: rgba(201,162,39,0.4);\n  transform: translateX(-50%);\n}\n.lantern::after {\n  content: '';\n  position: absolute;\n  bottom: -12px; left: 50%;\n  width: 2px; height: 12px;\n  background: var(--gold);\n  transform: translateX(-50%);\n}\n\n/* Mist drift */\n@keyframes mistDrift {\n  0% { transform: translateX(-30%) translateY(0); opacity: 0; }\n  20% { opacity: 0.7; }\n  80% { opacity: 0.5; }\n  100% { transform: translateX(130%) translateY(-20px); opacity: 0; }\n}\n.mist-cloud {\n  position: absolute;\n  width: 500px; height: 200px;\n  background: radial-gradient(ellipse, rgba(179,182,183,0.18) 0%, transparent 65%);\n  filter: blur(40px);\n  animation: mistDrift 28s linear infinite;\n  pointer-events: none;\n}\n\n/* Ember particle */\n@keyframes ember {\n  0% { transform: translateY(0) translateX(0); opacity: 0; }\n  10% { opacity: 1; }\n  100% { transform: translateY(-100vh) translateX(40px); opacity: 0; }\n}\n.ember {\n  position: absolute;\n  width: 3px; height: 3px;\n  background: var(--gold);\n  border-radius: 50%;\n  box-shadow: 0 0 6px 2px rgba(201,162,39,0.6);\n  animation: ember linear infinite;\n  bottom: 0;\n}\n\n/* Fade in animation utilities */\n@keyframes fadeUp {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n.fade-up { animation: fadeUp 1.2s ease-out forwards; }\n\n/* Hero gradient overlay */\n.hero-overlay {\n  background:\n    linear-gradient(180deg, rgba(8,8,8,0.45) 0%, rgba(8,8,8,0.6) 50%, var(--ink) 100%);\n}\n\n/* Tarot card style */\n.tarot-card {\n  background: linear-gradient(160deg, #1a1209 0%, #0a0805 100%);\n  border: 1px solid rgba(201,162,39,0.4);\n  position: relative;\n  aspect-ratio: 2 / 3;\n  overflow: hidden;\n}\n.tarot-card::before {\n  content: '';\n  position: absolute;\n  inset: 8px;\n  border: 1px solid rgba(201,162,39,0.25);\n  pointer-events: none;\n}\n.tarot-card::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at 50% 30%, rgba(201,162,39,0.15), transparent 60%);\n  pointer-events: none;\n}\n\n/* Timeline node glow */\n.book-node {\n  position: relative;\n  width: 14px; height: 14px;\n  background: var(--gold);\n  border-radius: 50%;\n  box-shadow: 0 0 12px 2px rgba(201,162,39,0.6);\n}\n\n/* Chinese-style corner ornament */\n.corner-orn {\n  position: absolute;\n  width: 28px; height: 28px;\n  border: 1px solid var(--gold);\n  opacity: 0.6;\n}\n.corner-orn.tl { top: 8px; left: 8px; border-right: none; border-bottom: none; }\n.corner-orn.tr { top: 8px; right: 8px; border-left: none; border-bottom: none; }\n.corner-orn.bl { bottom: 8px; left: 8px; border-right: none; border-top: none; }\n.corner-orn.br { bottom: 8px; right: 8px; border-left: none; border-top: none; }\n\n/* Hide debug wrapper */\n[data-debug-wrapper=\"true\"] { display: contents !important; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
